import React from 'react';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import { ptBR } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import { parse, format, isValid } from 'date-fns';

// Registrar locale brasileiro
registerLocale('pt-BR', ptBR);

/**
 * Componente de input de data com formato brasileiro (DD/MM/YYYY)
 *
 * @param {Object} props
 * @param {string} props.value - Data no formato DD/MM/YYYY ou YYYY-MM-DD
 * @param {function} props.onChange - Callback que recebe a data no formato DD/MM/YYYY
 * @param {string} props.className - Classes CSS adicionais
 * @param {string} props.placeholder - Placeholder do input
 * @param {boolean} props.disabled - Se o input está desabilitado
 * @param {Date} props.minDate - Data mínima permitida
 * @param {Date} props.maxDate - Data máxima permitida
 */
const DateInput = ({
    value,
    onChange,
    className = 'form-control form-control-sm',
    placeholder = 'DD/MM/AAAA',
    disabled = false,
    minDate = null,
    maxDate = null,
    id = null
}) => {
    // Converter o valor recebido para objeto Date
    const parseDate = (dateString) => {
        if (!dateString) return null;

        // Tentar parse no formato brasileiro DD/MM/YYYY
        let parsed = parse(dateString, 'dd/MM/yyyy', new Date());
        if (isValid(parsed)) return parsed;

        // Tentar parse no formato ISO YYYY-MM-DD
        parsed = parse(dateString, 'yyyy-MM-dd', new Date());
        if (isValid(parsed)) return parsed;

        // Tentar parse com separador de tempo
        const isoDate = dateString.split('T')[0];
        parsed = parse(isoDate, 'yyyy-MM-dd', new Date());
        if (isValid(parsed)) return parsed;

        return null;
    };

    const selectedDate = parseDate(value);

    const handleChange = (date) => {
        if (!date) {
            onChange('');
            return;
        }

        // Retornar no formato brasileiro DD/MM/YYYY
        const formattedDate = format(date, 'dd/MM/yyyy');
        onChange(formattedDate);
    };

    return (
        <DatePicker
            id={id}
            selected={selectedDate}
            onChange={handleChange}
            dateFormat="dd/MM/yyyy"
            locale="pt-BR"
            className={className}
            placeholderText={placeholder}
            disabled={disabled}
            minDate={minDate}
            maxDate={maxDate}
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={100}
            autoComplete="off"
            portalId="root"
            popperProps={{
                strategy: 'fixed'
            }}
            calendarClassName="custom-datepicker"
            popperClassName="custom-datepicker-popper"
        />
    );
};

export default DateInput;
